import { render, staticRenderFns } from "./OrdenCarouselComponent.vue?vue&type=template&id=edd5b558&scoped=true"
import script from "./OrdenCarouselComponent.vue?vue&type=script&lang=js"
export * from "./OrdenCarouselComponent.vue?vue&type=script&lang=js"
import style0 from "./OrdenCarouselComponent.vue?vue&type=style&index=0&id=edd5b558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd5b558",
  null
  
)

export default component.exports